import React from 'react';
import classNames from 'classnames';
import styles from './assets/seance-actions.module.scss';
import { IInvoice } from '../../../../../../types/invoice';
interface Props {
    original: Partial<IInvoice>;
    data: any;
    setData: any;
}

const InvoiceEditActionsColumn: React.FunctionComponent<Props> = ({ original, data, setData }) => {
    const handleChange = (event: any) => {
        const idValue = data[`${original?.id}`];
        if (idValue?.action) {
            delete data[`${original?.id}`];
            setData({
                ...data,
            });
        } else {
            setData({
                ...data,
                [`${original?.id}`]: {
                    ...idValue,
                    action: !idValue?.action,
                    remainingAmount: 0,
                },
            });
        }
    };

    const actionValue = data[`${original?.id}`]?.action;
    return (
        <div className={classNames(styles.actions)}>
            <input type="checkbox" checked={!!actionValue} onChange={(value) => handleChange(value)} />
        </div>
    );
};

export default InvoiceEditActionsColumn;
